import { useTranslation } from 'react-i18next';
import type { StatusFlag } from '@ctp/shared';
import { cn } from '../lib/cn';

const FLAG: Record<StatusFlag, { icon: string; cls: string }> = {
  ok: { icon: '✓', cls: 'border-status-ok/30 bg-status-ok/10 text-status-ok' },
  problem: { icon: '✕', cls: 'border-status-problem/30 bg-status-problem/10 text-status-problem' },
  unknown: { icon: '?', cls: 'border-status-unknown/30 bg-status-unknown/10 text-status-unknown' },
};

/** Status-Ampel je Feld (✓/✕/? in semantischer Farbe) mit Tooltip-Grund (PRD §6.2). */
export function StatusBadge({ label, flag, note }: { label: string; flag: StatusFlag; note?: string }): JSX.Element {
  const { t } = useTranslation();
  const title = note ?? t(`status.${flag}`);
  return (
    <div
      title={title}
      className={cn('flex min-w-[104px] flex-col items-center gap-1.5 rounded-lg border px-3 py-2.5', FLAG[flag].cls)}
    >
      <span className="flex h-7 w-7 items-center justify-center rounded-full border border-current text-sm font-bold" aria-hidden>
        {FLAG[flag].icon}
      </span>
      <span className="text-center text-xs font-medium text-foreground">{label}</span>
      <span className="sr-only">{title}</span>
    </div>
  );
}
